// Firebase Configuration
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXro-8Kl3bTbw_aRwD8m7LBgOXjH5APGY",
  authDomain: "kwac-scoring-app.firebaseapp.com",
  projectId: "kwac-scoring-app",
  storageBucket: "kwac-scoring-app.firebasestorage.app",
  messagingSenderId: "379668868025",
  appId: "1:379668868025:web:17967e3eb7862d2166a468"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// Set auth persistence
setPersistence(auth, browserLocalPersistence);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});

export const storage = getStorage(app);

export default app;